###
  BillingList widget
###

class INTENT.widgets.BillingList

  @ATTR_NAME: "data-widget-billing-list"

  @ATTR_FORM: "#{@ATTR_NAME}-form"

  @ATTR_FIELD: "#{@ATTR_NAME}-field"

  constructor: (@el) ->
    @s = @.constructor
    @init_select2()

    @form = @el.find "[#{@s.ATTR_FORM}]"

    @fields = @el.find "[#{@s.ATTR_FIELD}]"
    @field_advertiser = @fields.filter "[name='advertiser_id']"
    @field_currency = @fields.filter "[name='currency']"
    @field_sum = @fields.filter "[name='sum']"

    @form.on "submit", =>
      adv = parseInt @field_advertiser.val()
      if adv <= 0
        alert "First of all select advertiser"
        return false

      unless @field_sum.val().length
        alert "Sum must be valid"
        return false

    @field_advertiser.on "change", (e) =>
      self = $ e.target
      val = self.val()
      option = @field_advertiser.find "option[value='#{val}']"
      currency = option.attr('data-additional')
      @field_currency.attr 'value', currency

    @field_advertiser.change()

  init_select2: () =>
    @el.find('select').select2()

